module.exports = __webpack_public_path__ + "img/default_lexus.ec37dde2.png";